import { CSSProperties } from 'react'
export const CancelIcon = ({
  className = '',
  style = { color: '#0BB163', fontSize: '16px' },
}: {
  className?: string
  style?: CSSProperties
  onClick?: () => void
}) => (
  <svg
    width={style.fontSize}
    height={style.fontSize}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <circle cx="15.75" cy="15.5" r="15" fill={style.color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M10.475 10.2163C10.8655 9.83413 11.4987 9.83413 11.8892 10.2163L16.1821 14.4179L20.475 10.2163C20.8655 9.83413 21.4987 9.83413 21.8892 10.2163C22.2798 10.5986 22.2798 11.2183 21.8892 11.6005L17.5963 15.802L21.8892 20.0036C22.2798 20.3858 22.2798 21.0055 21.8892 21.3877C21.4987 21.7699 20.8655 21.7699 20.475 21.3877L16.1821 17.1862L11.8892 21.3877C11.4987 21.7699 10.8655 21.7699 10.475 21.3877C10.0845 21.0055 10.0845 20.3858 10.475 20.0036L14.7679 15.802L10.475 11.6005C10.0845 11.2183 10.0845 10.5986 10.475 10.2163Z"
      fill="white"
    />
  </svg>
)
